import { render, staticRenderFns } from "./AttrGalleryNew.vue?vue&type=template&id=a7b42840&"
import script from "./AttrGalleryNew.vue?vue&type=script&lang=js&"
export * from "./AttrGalleryNew.vue?vue&type=script&lang=js&"
import style0 from "./AttrGalleryNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports